import styled from 'styled-components';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import { Grid, GridItem } from '../../Grid';

export const AccordionCardGridItem = styled(GridItem)`
  /* Make card full height */
  display: flex;

  /* Make card full width */
  & > * {
    width: 100%;
  }
`;

export const StyledGrid = styled(Grid)`
  & {
    margin-top: ${spacing(2)};
    margin-bottom: ${spacing(-2)};

    /*  We alter the spacing for the last child (i.e. card grid in the accordion section)
        in order to get the correct spacing between the grid and the bottom of the section.
    */
    :last-child {
      margin-bottom: ${spacing(0)};

      ${mediaQuery.tabletPortrait`
        margin-bottom: ${spacing(-1)};
      `}

      ${mediaQuery.tabletLandscape`
        margin-bottom: ${spacing(-2)};
      `}
    }
  }
`;
